import { connect } from "react-redux";
import IAppStore from "app/IAppStore";

export interface IComponentRegistryBuilder<TProps, TActions, TExternalProps = any> {
    useState(mapper: StateMapper<TProps>): IComponentRegistryBuilder<TProps, TActions, TExternalProps>;
    useActions(actions: TActions): IComponentRegistryBuilder<TProps, TActions, TExternalProps>;

    build(): React.ComponentClass<TExternalProps>;
}

export type StateMapper<T> = (state: IAppStore) => T;
export type ActionMapper<T> = (actionSelector: any) => T;

class ComponentRegistryBuilder<TProps, TActions, TExternalProps = any> implements IComponentRegistryBuilder<TProps, TActions, TExternalProps> {
    
    constructor(private componentType: any) {

    }

    private _stateMapper: StateMapper<TProps> | null = null;
    useState(mapper: StateMapper<TProps>): IComponentRegistryBuilder<TProps, TActions, TExternalProps> {
        this._stateMapper = mapper;
        return this;
    }

    private _actions: TActions = null;
    useActions(actions: TActions): IComponentRegistryBuilder<TProps, TActions, TExternalProps> {
        this._actions = actions;
        return this;
    }

    build(): React.ComponentClass<TExternalProps>{
        const component = connect<any, any, TProps>(
            (state: any) => this.mapStateToProps(state), 
            this._actions
        )(this.componentType);

        //It's possible there's a better conversion, but this is a dumb hack
        //so that we can get compile errors for missing external props
        return component as unknown as React.ComponentClass<TExternalProps>;
    }

    private mapStateToProps(state: any): TProps {
        if (this._stateMapper == null) throw new Error("Method 'useState' has not been called"); 
        
        return this._stateMapper(state);
    }
}

export default  {
    register<TProps, TActions, TExternalProps = any>(componentType: any): IComponentRegistryBuilder<TProps, TActions, TExternalProps> {
        return new ComponentRegistryBuilder<TProps, TActions, TExternalProps>(componentType);
    }
    
}